// eslint-disable-next-line import/no-extraneous-dependencies
import AicUi from './AicUi/App';
// eslint-disable-next-line import/no-extraneous-dependencies
import $ from 'jquery';

if (document.querySelector('[data-mp-role="aic-form"]')) {
  // eslint-disable-next-line no-unused-vars
  const aicUi = new AicUi({
    aicAPIBaseURI: '/ai-concierge.js',
  });

  // トップページのAIコンシェルジュ簡易実行ボタンから遷移された場合に実行
  document.addEventListener('DOMContentLoaded', function() {
    const urlParams = new URLSearchParams(window.location.search);

    if (urlParams.has('commit') && urlParams.get('commit') === 'Go') {
      document.querySelector('[data-mp-role="aic-submit-btn"]').click();
    }
  });
}

$(() => {
  let previousValue;

  // 現在地取得成功時のみサーバに処理を送信する
  function successGetPosition(position) {
    const currentUrl = new URL(window.location.href);
    currentUrl.searchParams.set('lat', position.coords.latitude);
    currentUrl.searchParams.set('lng', position.coords.longitude);

    history.replaceState(null, '', currentUrl.toString());
  }

  function failGetPosition(error, event) {
    // eslint-disable-next-line default-case
    switch (error.code) {
      case error.PERMISSION_DENIED:
        // eslint-disable-next-line no-alert
        alert('位置情報の取得が許可されませんでした');
        break;
      case error.POSITION_UNAVAILABLE:
        // eslint-disable-next-line no-alert
        alert('電波状況などで位置情報が取得できませんでした');
        break;
      case error.TIMEOUT:
        // eslint-disable-next-line no-alert
        alert('位置情報の取得にてタイムアウトが発生しました');
        break;
      case error.UNKNOWN_ERROR:
        // eslint-disable-next-line no-alert
        alert('原因不明のエラーが発生しました');
        break;
    }
  }

  const startSpotSelect = document.querySelector('#start_spot');

  // スタート地点が現在地でコース生成が選ばれた場合
  if (startSpotSelect) {
    startSpotSelect.addEventListener('change', (event) => {
      const selectedValue = event.target.value;

      if (selectedValue === 'current_location') {
        const options = {
          enableHighAccuracy: true,
          timeout: 5000,
          maximumAge: 0,
        };

        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(
            (position) => {
              successGetPosition(position);
              previousValue = selectedValue; // 成功した場合のみ前回値を更新
            },
            (error) =>  {
              failGetPosition(error, event);
              event.target.value = previousValue; // エラー時に元の値に戻す
            },
            options
          );
        } else {
          // eslint-disable-next-line no-alert
          alert('ご使用中のブラウザは現在地検索に対応されておりません');
          event.target.value = previousValue;
        }
        return false;
      } else {
        previousValue = selectedValue; // 他の値を選択した場合、前回値を更新
      }
    });
  }
});
